<template>
  <div class="accordion-list-item" :style="listItemStyle">
    <div class="accordion-list-item__main open" style="margin-bottom: 1px" @click.stop="clickSub()">
      <lego-checkbox
        v-if="check"
        :indeterminate="indeterminate"
        :readonly="readonly"
        v-model="checked"
        class="list-item__check"
      />
      <lego-radio
        v-else-if="radio"
        v-model="checked"
        :readonly="readonly"
        class="list-item__check"
      />
      <div class="item-title-sec">
        <slot name="title"> {{ title }}</slot>
      </div>
      <div
        v-if="expandable"
        class="expand-icon"
        :class="{ open: isExpend }"
        @click.stop="toggleExpand"
      >
        <lego-icon iconType="df" :size="16">{{ iconName }}</lego-icon>
      </div>
    </div>
    <div v-if="isExpend" class="accordion-list-item__expand">
      <slot name="expand"></slot>
    </div>
  </div>
</template>
<script>
import legoAccordionItem from '../../lego/extend/legoAccordionItem.vue';

export default {
  mixins: [legoAccordionItem],
  name: 'scpmAccordionItem',

  methods: {
    clickSub() {
      this.$emit('clickSub');
    },

    toggleExpand() {
      this.isExpend = !this.isExpend;
      this.$emit('toggle', this.isExpend);
      this.$emit('scrollIntoView');
    }
  }
};
</script>
<style lang="scss" scoped>
.accordion-list-item {
  border: 1px solid $color--ui08;
  background-color: $color--ui-white;

  & + .accordion-list-item {
    margin-top: 6px;
  }

  &__main {
    display: flex;
    align-items: center;
    padding: 0 8px 0 16px;
    cursor: pointer;

    &:hover {
      background-color: #eef2fc;
    }

    .lego-checkbox,
    .lego-radio {
      flex: none;
      margin-right: 8px;

      &:hover {
        & + .item-title-sec {
          color: inherit;

          :deep & + .expand-icon {
            .lego-icon {
              color: rgba($color--ui01, 0.6);
            }
          }
        }
      }
    }
    .item-title-sec {
      flex: 1 1 auto;
      @include font(14px);
    }

    .expand-icon {
      cursor: pointer;
      padding: 10px;

      :deep .lego-icon {
        vertical-align: middle;
      }

      :deep &.open {
        .lego-icon {
          transform: rotate(-180deg);
        }
      }
    }
  }

  &__expand {
    border-top: 1px solid $color--ui08;
    margin: 0 20px;
    padding: 8px 12px;
  }
}
</style>
